// src/Components/PharmacyContext.js
import React from 'react';

const PharmacyContext = React.createContext(null);

export default PharmacyContext;
